module.exports = __webpack_public_path__ + "img/souls-background.b5074dcc.png";